import React, { createContext, useContext, useEffect, useState } from 'react';
import { api } from '../services/api';

const AuthContext = createContext(null);
const KEY = 'av_auth'; // resposta completa do login: { accessToken, refreshToken, user }
// Chaves legadas (mock) mantidas em sincronia para leitores antigos e fallback.
const TOKEN_KEY = 'authToken';
const USER_KEY = 'user';

function persistSession(session) {
  if (!session) return;
  localStorage.setItem(KEY, JSON.stringify(session));
  if (session.accessToken) localStorage.setItem(TOKEN_KEY, session.accessToken);
  if (session.token) localStorage.setItem(TOKEN_KEY, session.token); // formato mock antigo
  if (session.user) localStorage.setItem(USER_KEY, JSON.stringify(session.user));
}

function clearPersistedSession() {
  localStorage.removeItem(KEY);
  localStorage.removeItem(TOKEN_KEY);
  localStorage.removeItem(USER_KEY);
}

export function AuthProvider({ children }) {
  const [auth, setAuth] = useState(null);
  const [ready, setReady] = useState(false);

  useEffect(() => {
    try {
      const raw = localStorage.getItem(KEY);
      if (raw) {
        const session = JSON.parse(raw);
        persistSession(session); // re-sincroniza chaves legadas após refresh
        setAuth(session);
      }
    } catch (e) {
      /* ignore */
    }
    setReady(true);
  }, []);

  async function login(email, password) {
    const res = await api.login(email, password);
    persistSession(res);
    setAuth(res);
    return res;
  }

  function logout() {
    clearPersistedSession();
    setAuth(null);
  }

  return (
    <AuthContext.Provider value={{ auth, ready, login, logout, isAuthed: !!auth }}>
      {children}
    </AuthContext.Provider>
  );
}

export function useAuth() {
  const ctx = useContext(AuthContext);
  if (!ctx) throw new Error('useAuth must be used within AuthProvider');
  return ctx;
}
